var _g, _g2, _g3, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 32,
    viewBox: "0 0 234 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2609 23.0265L23.1202 27.9998L21.0346 18.6265L27.9783 12.3198L18.8345 11.5065L15.2609 2.6665L11.6873 11.5065L2.54349 12.3198L9.48718 18.6265L7.40153 27.9998L15.2609 23.0265Z",
    fill: "#FFA800"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_435_634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.1304 23.0265L73.9898 27.9998L71.9041 18.6265L78.8478 12.3198L69.704 11.5065L66.1304 2.6665L62.5569 11.5065L53.4131 12.3198L60.3568 18.6265L58.2711 27.9998L66.1304 23.0265Z",
    fill: "#FFA800"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_435_634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117 23.0265L124.859 27.9998L122.774 18.6265L129.717 12.3198L120.574 11.5065L117 2.6665L113.426 11.5065L104.283 12.3198L111.226 18.6265L109.141 27.9998L117 23.0265Z",
    fill: "#FFA800"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.87 23.0265L175.729 27.9998L173.643 18.6265L180.587 12.3198L171.443 11.5065L167.87 2.6665L164.296 11.5065L155.152 12.3198L162.096 18.6265L160.01 27.9998L167.87 23.0265Z",
    fill: "#FFA800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.739 9.5065L219.973 12.5598L220.57 14.0398L222.097 14.1732L225.238 14.4532L222.847 16.6265L221.69 17.6798L222.033 19.2532L222.745 22.4665L220.049 20.7598L218.739 19.9065L217.429 20.7332L214.733 22.4398L215.445 19.2265L215.789 17.6532L214.631 16.5998L212.241 14.4265L215.382 14.1465L216.908 14.0132L217.506 12.5332L218.739 9.5065V9.5065ZM218.739 2.6665L215.166 11.5065L206.022 12.3198L212.965 18.6265L210.88 27.9998L218.739 23.0265L226.598 27.9998L224.513 18.6265L231.457 12.3198L222.313 11.5065L218.739 2.6665Z",
    fill: "#FFA800"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5217,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_435_634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5217,
    height: 32,
    fill: "white",
    transform: "translate(50.8696)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_435_634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5217,
    height: 32,
    fill: "white",
    transform: "translate(101.739)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate);
export default __webpack_public_path__ + "static/media/rate.f760ed7e8e7ccbf91678a7e95e14ceff.svg";
export { ForwardRef as ReactComponent };